import React from "react";
import styles from "./Footer.module.css";
import logo from "../assets/linked.png";
import { FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerBottom}>
        <div className={styles.socialIcons} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <a
            href="https://www.linkedin.com/company/kasibhatlaws-in/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src={logo}
              alt="logo"
              style={{ width: "80px", height: "30px" }}
            />
          </a>
          <a
            href="https://www.instagram.com/kasibhatlaws?utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "white", display: "flex", alignItems: "center" }}
          >
            <FaInstagram size={28} />
             <span style={{ marginLeft: "8px", fontSize: "16px",fontWeight:"bold" }}>Instagram</span>
          </a>
          
        </div>
        <span className={styles.copyright}>
          © {new Date().getFullYear()} KASIBHATLAWS &mdash; All rights reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
